import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import ProcessSidePanel from 'modules/processes/components/ProcessSidePanel'
import { useProcess } from 'modules/processes/hooks/useProcess'

type Props = {
  processId: number
  onSuccess: () => void
  onClose: () => void
}

const EditProcessModal = ({ processId, onSuccess, onClose }: Props) => {
  const { process } = useProcess(processId)

  return <ProcessSidePanel onClose={onClose} process={process} onSuccess={onSuccess} />
}

const EditProcessModalPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const onReturn = () => {
    navigate(-1)
  }

  if (!id) {
    onReturn()
    return null
  }

  return <EditProcessModal processId={Number(id)} onClose={onReturn} onSuccess={onReturn} />
}

export default EditProcessModalPage
